import { makeStyles } from "tss-react/mui";
import { alpha, darken } from "@mui/material/styles";
import {
  gradientBgLight,
  gradientBgDark,
} from "containers/Templates/appStyles-jss";

const sectionSpace = 96;
const sectionSpaceMobile = 80;
const screenPreview = {
  transform: "scale(0.8)",
  position: "absolute",
  // bottom: 0,
  top: "25%",
  zIndex: 1,
};

const useStyles = makeStyles()((theme, _params, classes) => ({
  container: {
    padding: `0 ${theme.spacing(2)}`,
    position: "relative",
    margin: "0 auto",
    [theme.breakpoints.up("xl")]: {
      width: 1450,
      padding: 0,
    },
  },
  topHeaderContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  spaceContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  button: {
    // margin: theme.spacing(1),
    "& i": {
      fontSize: "1rem",
    },
  },
  brandLogo: {
    "& img": {
      width: "270px",
    },
  },

  footer: {
    // background:
    //   theme.palette.mode === "dark"
    //     ? gradientBgDark(theme)
    //     : gradientBgLight(theme),
    background: "#aac1fd",
    padding: "1px 0",
    width: "100%",
    "@media (min-width: 767px)": {},
    overflow: "hidden",
    [`& .${classes.brand}`]: {
      color: theme.palette.text.primary,
    },
    "& nav": {
      "& li": {
        display: "inline-block",
        margin: `0 ${theme.spacing(3)}`,
        "& a": {
          fontSize: 11,
          textTransform: "capitalize",
          fontWeight: theme.typography.fontWeightRegular,
        },
      },
    },
    [`& .${classes.spaceContainer}`]: {
      [theme.breakpoints.down("md")]: {
        flexDirection: "column",
        "& ul": {
          textAlign: "center",
          marginTop: theme.spacing(3),
        },
      },
    },
    [`& .${classes.container}`]: {
      [theme.breakpoints.down("md")]: {
        flexDirection: "column",
        alignItems: "center",
      },
    },
  },
  footerDecoration: {
    width: "100%",
    position: "absolute",
    top: 0,
    height: 330,
    visibility: "hidden",
    fill:
      theme.palette.mode === "dark"
        ? darken(theme.palette.primary.main, 0.7)
        : theme.palette.primary.light,
    [theme.breakpoints.up(1400)]: {
      transform: "scale(2, 1)",
    },
    [theme.breakpoints.up("xl")]: {
      background:
        theme.palette.mode === "dark"
          ? darken(theme.palette.primary.main, 0.7)
          : theme.palette.primary.light,
    },
  },

  lowerFooter: {
    "@media (max-width: 768px)": {
      display: "flex",
      flexDirection: "row",
      maxWidth: "100%",
      alignItems: "center",
      width: "100vw",
      justifyContent: "center",
      margin: "0px",
    },
    display: "flex",
    alignItems: "center",
    maxWidth: "100%",
    width: "100vw",
  },
}));

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export default useStyles;
